import { toast } from "@/view/components/ui/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { customerService } from "@/app/services/customerService";
import { HandleCustomerStatusParams } from "@/app/services/customerService/handleCustomerStatus";

export const useCustomerMutations = () => {
  const queryClient = useQueryClient();

  const updateStatus = useMutation({
    mutationFn: (input: HandleCustomerStatusParams) =>
      customerService.handleCustomerStatus(input),
    onSuccess: (_, { action }) => {
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      toast({
        title:
          action === "archive"
            ? "Cliente arquivado com sucesso."
            : action === "unarchive"
              ? "Cliente desarquivado com sucesso."
              : "Contato registrado com sucesso.",
      });
    },
    onError: () => {
      toast({
        variant: "destructive",
        title: "Erro ao atualizar cliente. Tente novamente mais tarde.",
      });
    },
  });

  return {
    updateCustomerStatus: updateStatus.mutateAsync,
    isUpdatingStatus: updateStatus.isPending,
  };
};
